import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { TabsContent } from '../../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { ScrollArea } from '../../../components/ui/scroll-area';
import { Skeleton } from '../../../components/ui/skeleton';
import { Building2, Phone, ArrowUpRight, Plus, Edit } from 'lucide-react';

export const BiginCompaniesTab = ({ companies, loading, openCreateCompany, openEditCompany }) => (
        <TabsContent value="companies" className="mt-4">
          <Card className="bg-white border shadow-sm">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="text-lg">Companies</CardTitle>
                  <CardDescription>{companies.length} companies synced</CardDescription>
                </div>
                <Button onClick={openCreateCompany} className="bg-purple-600 hover:bg-purple-700">
                  <Plus className="w-4 h-4 mr-2" /> Add Company
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="space-y-3">
                  {[1, 2, 3].map(i => <Skeleton key={i} className="h-16 w-full" />)}
                </div>
              ) : companies.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Building2 className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                  <p>No companies found. Click "Sync Now" to fetch data from Bigin or "Add Company" to create one.</p>
                </div>
              ) : (
                <ScrollArea className="h-[400px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Company Name</TableHead>
                        <TableHead>Website</TableHead>
                        <TableHead>Phone</TableHead>
                        <TableHead>Industry</TableHead>
                        <TableHead>Owner</TableHead>
                        <TableHead className="w-24">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {companies.map((company) => (
                        <TableRow key={company.bigin_id || company.id} data-testid="company-row">
                          <TableCell className="font-medium">
                            {company.Account_Name || 'Unnamed Company'}
                          </TableCell>
                          <TableCell>
                            {company.Website ? (
                              <a 
                                href={company.Website.startsWith('http') ? company.Website : `https://${company.Website}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-[hsl(187,70%,38%)] hover:underline flex items-center gap-1"
                              >
                                {company.Website}
                                <ArrowUpRight className="w-3 h-3" />
                              </a>
                            ) : 'N/A'}
                          </TableCell>
                          <TableCell>
                            {company.Phone ? (
                              <span className="flex items-center gap-1 text-gray-600">
                                <Phone className="w-3 h-3" />
                                {company.Phone}
                              </span>
                            ) : 'N/A'}
                          </TableCell>
                          <TableCell>{company.Industry || 'N/A'}</TableCell>
                          <TableCell className="text-gray-500">
                            {company.Owner?.name || 'Unassigned'}
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1">
                              <Button variant="ghost" size="sm" onClick={() => openEditCompany(company)} className="h-8 w-8 p-0">
                                <Edit className="w-4 h-4 text-gray-500" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>
);
